/**
 * Online Ordering Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OrderTypeEnum {

    Delivery = 'delivery',

    Takeaway = 'takeaway',

    DineIn = 'dineIn',

    Pos = 'pos',

    Pickup = 'pickup',

    DriveThru = 'driveThru'
}

